export function getTutorialCardLayout(availableWidth: number, step: number, canUseAI: boolean) {
  const surfaceWidth = Math.min(availableWidth, 480);
  const surfaceLeft = (availableWidth - surfaceWidth) / 2;
  const cardWidth = Math.min(343, surfaceWidth - 32);
  const cardOffsets: readonly number[] = canUseAI ? [16, 2, 14] : [16, 14];
  const cardOffset = cardOffsets[step] ?? cardOffsets.at(-1) ?? 0;
  const cardLeft = Math.max(
    surfaceLeft + 8,
    Math.min(surfaceLeft + (surfaceWidth - cardWidth) / 2 + cardOffset, surfaceLeft + surfaceWidth - cardWidth - 8),
  );
  return { cardLeft, cardWidth };
}
